module.exports = __webpack_public_path__ + "assets/img/ActivityMonitoring.e6218138.png";